<template>
  <div class="multiple-devices-error-message">
    <div class="error-header">
      <v-icon color="error">
        {{ errorIcon }}
      </v-icon>
      <div class="error-title">
        {{ errorTitle }}
      </div>
    </div>
    <div v-if="errors" :class="`error-description ${errorType}`">
      <ErrorList v-if="errorType === 'list'" :errors="errorList" />
      <span v-else>
        {{ formattedErrors[0] }}
        <a
          v-if="formattedErrors && formattedErrors.length >= 2"
          href="csv/Bulk device registration import template.csv"
          class="download-link"
          download
        >
          {{ formattedErrors[1] }}
        </a>
        <span v-if="formattedErrors && formattedErrors.length >= 3">
          {{ formattedErrors[2] }}
        </span>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import ErrorList from './content/errorList.vue'

export default defineComponent({
  name: 'MultipleDevicesErrorMessage',
  components: {
    ErrorList
  },
  props: {
    icon: String,
    title: String,
    errors: [String, Array] as PropType<string | string[]>
  },
  computed: {
    errorTitle(): string {
      return this.title || String(this.$t('registerMultipleDevices.uploadFailed'))
    },
    errorIcon(): string {
      return this.icon || 'mdi-alert-circle'
    },
    errorType(): 'list' | 'single' {
      return Array.isArray(this.errors) && this.errors.length ? 'list' : 'single'
    },
    errorList(): string[] {
      return Array.isArray(this.errors) ? this.errors : []
    },
    formattedErrors(): string[] {
      if (typeof this.errors === 'string') {
        return this.errors.split('-')
      }

      return Array.isArray(this.errors) ? this.errors : []
    }
  }
})
</script>

<style lang="scss" scoped>
.multiple-devices-error-message {
  .error-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0.3rem 0;
    height: 40%;

    .v-icon {
      font-size: 7vh;
    }
  }

  .error-title {
    margin-top: 1rem;
    font-size: 1.2rem;
    font-weight: 500;
  }

  .error-description.single {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 1rem;
    padding: 0.5rem;
    height: 45%;
  }

  @media (max-width: 599px), (max-height: 770px) {
    .error-title {
      font-size: 1rem !important;
      margin-top: 0.5rem;
    }
  }

  @media (max-width: 599px) {
    .error-description.single {
      font-size: 0.9rem;
    }
  }

  @media (max-height: 469px) {
    .error-header {
      margin: 0.5rem 0;
    }

    .error-title {
      font-size: 0.9rem !important;
      margin: 0;
    }

    .error-description.single {
      font-size: 0.8rem;
      padding: 0 0.5rem;
      height: 35%;
    }
  }

  @media (min-height: 1000px) {
    .error-header {
      .v-icon {
        font-size: 3.5rem !important;
      }
    }
  }
}
</style>
